'use strict';

(function (angular) {
  angular.module('zp').controller('MapHoneyMoonController', mapHoneyMoonController);

  /**@ngInject */
  function mapHoneyMoonController($q, $window, $timeout, $state, mapConfig, SearchService, $uibModal, LoaderService) {
    var vm = this;

    vm.honeyMoons = [];
    vm.mapOptions = angular.copy(mapConfig.mapOptions);
    vm.mapMarkers = [];
    vm.selectedDestination = null;
    vm.sidebarStyle = { width: $window.innerWidth > 768 ? '250px' : '0px' };

    vm.onLocationClicked = onLocationClicked;
    vm.openWebsite = openWebsite;
    vm.openGallery = openGallery;
    vm.selectDestination = selectDestination;
    vm.removeSelection = removeSelection;
    vm.toggleSidebar = toggleSidebar;

    /**activate */
    (function () {
      LoaderService.start();
      loadHoneyMoons().then(loadMapMarkers).then(setMapOptions).then(setDestination).then(function () {
        $timeout(function () {
          LoaderService.stop();
        }, 1000);
      });
    })();

    function loadHoneyMoons() {
      return SearchService.getHoneyMoons().then(function (response) {
        vm.honeyMoons = response;
      });
    }

    function loadMapMarkers() {
      return $q.when(function () {
        for (var i = 0; i < vm.honeyMoons.length; i++) {
          vm.mapMarkers.push({
            index: i,
            latitude: vm.honeyMoons[i].location.latitude,
            longitude: vm.honeyMoons[i].location.longitude,
            selected: false
          });
        }
      }());
    }

    function setMapOptions() {
      return $q.when(function () {
        vm.mapOptions.mapCenter = vm.mapMarkers.length ? vm.mapMarkers[0] : { latitude: 44, longitude: 20 };
        vm.mapOptions.disableDefaultUI = true;
        vm.mapOptions.zoomControl = true;
        vm.mapOptions.streetViewControl = true;
        vm.mapOptions.draggable = true;
        vm.mapOptions.scrollwheel = true;
        vm.mapOptions.disableDoubleClickZoom = false;
        vm.mapOptions.zoom = 5;
        return true;
      }());
    }

    function toggleSidebar() {
      if (vm.sidebarStyle.width && vm.sidebarStyle.width === '250px') {
        vm.sidebarStyle.width = '0px';
      } else {
        vm.sidebarStyle.width = '250px';
      }
    }

    function onLocationClicked(marker) {
      vm.selectedDestination = null;
      $timeout(function () {
        vm.selectedDestination = vm.honeyMoons[marker.index];
        $state.go('nav.honey-moon', { destination: vm.selectedDestination.alias }, { notify: false });
      }, 300);
    }

    function openWebsite(agency) {
      $window.open(agency.website, '_blank');
    }

    function openGallery(_honeyMoon, _index) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/map/map.honey.moon.gallery.html',
        controller: 'HoneyMoonGalleryController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          honeyMoon: function honeyMoon() {
            return _honeyMoon;
          },
          index: function index() {
            return _index;
          }
        }
      });
    }

    function setDestination() {
      return $q.when(function () {
        if ($state.params.destination) {
          for (var i = 0; i < vm.honeyMoons.length; i++) {
            if ($state.params.destination === vm.honeyMoons[i].alias) {
              vm.selectedDestination = vm.honeyMoons[i];
              vm.mapMarkers[i].selected = true;
            }
          }
        }
      }());
    }

    function selectDestination(destination) {
      for (var i = 0; i < vm.mapMarkers.length; i++) {
        vm.mapMarkers[i].selected = destination.alias === vm.honeyMoons[i].alias;
      }
      var selected = vm.mapMarkers.find(function (a) {
        return a.selected;
      });
      onLocationClicked(selected);
    }

    function removeSelection() {
      for (var i = 0; i < vm.mapMarkers.length; i++) {
        vm.mapMarkers[i].selected = false;
      }
      vm.selectedDestination = null;
      $state.go('nav.honey-moon', { destination: null }, { notify: false });
    }
  }
})(window.angular);